module.exports = __webpack_public_path__ + "img/mv_title_pc.ae79effd.svg";